import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Checkbox,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TablePagination,
    TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CSVLink } from "react-csv";
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { FaEye } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { LiaCogSolid } from "react-icons/lia";

const useStyles = makeStyles(() => ({
    tableContainer: {
        margin: "20px auto",
        width: "95%",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#ffffff",
        padding: "20px"
    },
    tableHead: {
        backgroundColor: "#1C375D",
        height: "40px",
    },
    tableHeadCell: {
        color: "#FFF2EB",
        fontWeight: "bold",
        fontSize: "14px",
        padding: "8px",
        textAlign: "center",
    },
    tableRow: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#f9f9f9",
        },
        "&:hover": {
            backgroundColor: "#e6f7ff",
            cursor: "pointer",
        },
    },
    tableCell: {
        padding: "10px",
        textAlign: "center",
        fontSize: "14px",
        color: "#333",
    },
    button: {
        marginTop: "10px",
        backgroundColor: "#1976d2",
        color: "#FFF2EB",
        "&:hover": {
            backgroundColor: "#135ba1",
        },
    },
}));

const Referral = (props) => {
    const classes = useStyles();
    const history = useHistory()
    const [referrals, setReferrals] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogStep, setDialogStep] = useState(1);
    const [filterType, setFilterType] = useState("all");
    const [openBankDialog, setOpenBankDialog] = useState(false);
    const [selectedBankDetails, setSelectedBankDetails] = useState(null);
    const [paymentStatusFilter, setPaymentStatusFilter] = useState("all");
    const [page, setPage] = useState(0); 
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [dateRange, setDateRange] = useState({
        startDate: "",
        endDate: ""
    });

    const showBankDialog = (bankDetails) => {
        setSelectedBankDetails(bankDetails);
        setOpenBankDialog(true);
    };

    const handleCloseBankDialog = () => {
        setOpenBankDialog(false);
        setSelectedBankDetails(null);
    };

    useEffect(() => {
        fetchReferralData(filterType, paymentStatusFilter,page + 1, rowsPerPage,dateRange.startDate, dateRange.endDate);
    }, [filterType, paymentStatusFilter, page, rowsPerPage]);


    const fetchReferralData = async (type, paymentStatus, page, limit,startDate = null, endDate = null) => {
        props.setLoading(true);
        try {
            const response = await HttpService.getReferralData(type, paymentStatus, page, limit,startDate, endDate)
            setReferrals(response.data.data);
            setTotalCount(response.data.pagination.total);
            props.setLoading(false);
        } catch (error) {
            console.error("Error fetching referrals:", error);
        }
    };
      // Handle date range changes
      const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle date filter submission
    const handleDateFilterSubmit = () => {
        setPage(0); 
        fetchReferralData(
            filterType, 
            paymentStatusFilter, 
            1,
            rowsPerPage, 
            dateRange.startDate, 
            dateRange.endDate
        );
    };

    // Clear all filters
    const handleClearFilters = () => {
        setFilterType("all");
        setPaymentStatusFilter("all");
        setDateRange({
            startDate: "",
            endDate: ""
        });
        setPage(0);
        fetchReferralData("all", "all", 1, rowsPerPage);
    };
     // Pagination function
     const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); 
    };

    const handleRowClick = (lead) => {
        setSelectedLead(lead);
        setDialogStep(1);
        setOpenDialog(true);
    };

    const handleNext = () => setDialogStep(2);
    const handlePrevious = () => setDialogStep(1);

    const handleCloseDialog = () => setOpenDialog(false);
    const togglePayment = async (type) => {
        if (!selectedLead) return;

        const paymentType = type === "officeMeetReferralPayment" ? "officeMeetReferralPayment" : "kickOffReferralPayment";
        const newStatus = !selectedLead[paymentType].status;
        props.setLoading(true);
        try {
            const response = await HttpService.paymentUpdate(selectedLead.leadId?._id, {
                type: paymentType,
                status: newStatus,
            });

            setSelectedLead((prevLead) => ({
                ...prevLead,
                [paymentType]: {
                    ...prevLead[paymentType],
                    status: newStatus,
                },
            }));
            props.setSnackInfo(response?.data?.msg)

            // Update the referrals list to reflect changes
            setReferrals((prevReferrals) =>
                prevReferrals.map((ref) =>
                    ref.leadId?._id === selectedLead.leadId?._id
                        ? { ...ref, [paymentType]: { ...ref[paymentType], status: newStatus } }
                        : ref
                )
            );
            fetchReferralData(filterType, paymentStatusFilter, page + 1, rowsPerPage,dateRange.startDate, dateRange.endDate);
            props.setLoading(false);
        } catch (error) {
            console.error("Error updating payment status:", error);
            props.setSnackInfo("Error updating payment status")
        }
    };
    const handleNavigateToProjectLogs = () => {
        if (selectedLead?.leadId?._id) {
            window.open(`/project-logs/${selectedLead.leadId._id}`, '_blank');
        }
    };
    const handleNavigateToProjectLogsFromReferredBy = () => {
        if (selectedLead?.referrerLeadInfo?._id) {
            window.open(`/project-logs/${selectedLead?.referrerLeadInfo?._id}`, '_blank');
        }
    };


    return (
        <Paper className={classes.tableContainer}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box style={{
                    width: "25%", display: "flex", justifyContent: "space-between"
                }}>
                    <FormControl variant="outlined" size="small" style={{ width: "150px" }}>
                        <InputLabel>Referral Type</InputLabel>
                        <Select
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                            label="Referral Type"
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="Customer">Customer</MenuItem>
                            <MenuItem value="Employee">Employee</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small" style={{ width: "150px" }}>
                        <InputLabel>Payment Status</InputLabel>
                        <Select
                            value={paymentStatusFilter}
                            onChange={(e) => setPaymentStatusFilter(e.target.value)}
                            label="Payment Status"
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="paid">Paid</MenuItem>
                            <MenuItem value="partially_paid">Partially Paid</MenuItem>
                            <MenuItem value="unpaid">Unpaid</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
             
                <Button variant="contained"
                    style={{
                        backgroundColor: "rgb(244, 126, 70)",
                        color: "white",
                    }}>
                    <CSVLink data={referrals.map(({ leadId, officeMeetReferralPayment, kickOffReferralPayment, referalType, referedBy, referedTo, createdAt }) => ({
                        lead_no: leadId?.lead_no || "N/A",
                        referalType,
                        referedBy,
                        referedTo,
                        referalType,
                        officeMeetReferralAmount: officeMeetReferralPayment.amount,
                        officeMeetReferralPaymentDone: officeMeetReferralPayment.status,
                        signOffReferralPayment: kickOffReferralPayment.amount,
                        signOffReferralPaymentDone: kickOffReferralPayment.status,
                        referredOn: moment(createdAt).format("DD-MM-YYYY"),
                    }))} filename="filtered_referrals.csv" style={{ textDecoration: "none", color: "white" }}>
                        Download CSV
                    </CSVLink>
                </Button>
            </Box>
            <Paper className={classes.paper} style={{ padding: "16px",marginBottom:"16px" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} width="50%">
                    {/* From Date */}
                    <TextField
                        id="date"
                        name="startDate"
                        label="From Date"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        className={classes.textField}
                        fullWidth
                        value={dateRange.startDate}
                        onChange={handleDateChange}
                    />

                    {/* End Date */}
                    <TextField
                         id="endDate"
                         name="endDate"
                         label="End Date"
                         type="date"
                         value={dateRange.endDate}
                         onChange={handleDateChange}
                         InputLabelProps={{ shrink: true }}
                         className={classes.textField}
                         fullWidth
                    />

                    {/* Submit Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ 
                            height: "40px", 
                            width: "60%",
                            marginLeft: "40px",
                            backgroundColor: !dateRange.startDate || !dateRange.endDate 
                                ? "rgba(244, 126, 70, 0.5)" 
                                : "rgb(244, 126, 70)",
                            color: "white",
                            opacity: !dateRange.startDate || !dateRange.endDate ? 0.7 : 1
                        }}
                        disabled={!dateRange.startDate || !dateRange.endDate}
                        onClick={handleDateFilterSubmit}
                    >
                        Submit
                    </Button>

                    {/* Clear Filter  */}
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{ height: "40px",width:"60%" ,marginLeft:"40px"}}
                        onClick={handleClearFilters}
                    >
                        Clear
                    </Button>
                </Box>
            </Paper>

            <TableContainer>
                <Table>
                    <TableHead className={classes.tableHead}>
                        <TableRow>
                            <TableCell className={classes.tableHeadCell}>Sl No</TableCell>
                            <TableCell className={classes.tableHeadCell}>Lead No</TableCell>
                            <TableCell className={classes.tableHeadCell}>Referred By</TableCell>
                            <TableCell className={classes.tableHeadCell}>Referred To</TableCell>
                            <TableCell className={classes.tableHeadCell}>Referred On</TableCell>
                            <TableCell className={classes.tableHeadCell}>Referral Type</TableCell>
                            <TableCell className={classes.tableHeadCell}>Total Amount</TableCell>
                            <TableCell className={classes.tableHeadCell}>Payment Status</TableCell>
                            <TableCell className={classes.tableHeadCell}>Bank details</TableCell>
                            <TableCell className={classes.tableHeadCell}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {referrals.map((item, index) => (
                            <TableRow key={item._id}>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell>
                                    <Button color="primary" onClick={() => handleRowClick(item)}>
                                        {item.leadId.lead_no || "N/A"}
                                    </Button>
                                </TableCell>
                                {/* <TableCell>{item.referedBy}</TableCell> */}
                                <TableCell >
                                    {item?.referalType === "Customer" ? (
                                        <span
                                            component="span"
                                            color="primary"
                                            style={{ cursor: "pointer", textDecoration: "underline" }}
                                            onClick={() => window.open(`/project-logs/${item?.referrerLeadInfo?._id}`, '_blank')}
                                        >
                                            {item?.referedBy}
                                        </span>
                                    ) : (
                                        item?.referedBy
                                    )}
                                </TableCell>
                                <TableCell>{item.referedTo}</TableCell>
                                <TableCell>{moment(item.createdAt).format("DD-MM-YY")}</TableCell>
                                <TableCell>{item.referalType}</TableCell>
                                <TableCell>{item.officeMeetReferralPayment.amount + item.kickOffReferralPayment.amount}</TableCell>
                                <TableCell>
                                    {item.officeMeetReferralPayment.status && item.kickOffReferralPayment.status
                                        ? "Paid"
                                        : item.officeMeetReferralPayment.status || item.kickOffReferralPayment.status
                                            ? "Partially Paid"
                                            : "Unpaid"}
                                </TableCell>
                                <TableCell>  {item.bankDetails ? (
                                    <FaEye
                                        size={20}
                                        style={{ cursor: "pointer", color:"black" }}
                                        onClick={() => showBankDialog(item.bankDetails)}
                                    />
                                ) : (
                                    "NA"
                                )} </TableCell>
                                <TableCell>
                                    <LiaCogSolid
                                        size={20}
                                        style={{
                                            cursor: "pointer",
                                            color: "black",
                                            transition: "transform 0.3s ease-in-out"
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = "rotate(90deg) scale(1.2)"}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = "rotate(0deg) scale(1)"}
                                        onClick={() => handleRowClick(item)}
                                    />
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
            />
            </TableContainer>
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {dialogStep === 1 ? "Site Visit Referral Payment" : "Design Signoff Referral Payment"}
                </DialogTitle>
                <DialogContent>
                    {selectedLead && (
                        <Box>
                            <Typography onClick={handleNavigateToProjectLogs}><b>Lead No:</b> <span component="span"
                                color="primary"
                                style={{ cursor: "pointer", textDecoration: "underline" }}>
                                {selectedLead.leadId.lead_no}</span>
                            </Typography>
                            <Typography>
                                <b>Referred By:</b>{" "}
                                {selectedLead?.referalType === "Customer" && selectedLead?.referrerLeadInfo?._id ? (
                                    <span
                                        component="span"
                                        color="primary"
                                        style={{ cursor: "pointer", textDecoration: "underline" }}
                                        onClick={handleNavigateToProjectLogsFromReferredBy}
                                    >
                                        {selectedLead?.referedBy}
                                    </span>
                                ) : (
                                    selectedLead?.referedBy
                                )}
                            </Typography>
                            <Typography><b>Referred To:</b> {selectedLead.referedTo}</Typography>
                            <Typography><b>Referral Type:</b>{selectedLead.referalType}</Typography>

                            <Typography>
                                <b>Amount:</b> {dialogStep === 1
                                    ? selectedLead.officeMeetReferralPayment.amount
                                    : selectedLead.kickOffReferralPayment.amount}
                            </Typography>

                            {/* Payment status checkbox */}
                            <Box mt={2}>
                                <Typography><b>Payment Status:</b></Typography>
                                <Checkbox
                                    checked={dialogStep === 1
                                        ? selectedLead.officeMeetReferralPayment.status
                                        : selectedLead.kickOffReferralPayment.status}
                                    onChange={() => togglePayment(dialogStep === 1
                                        ? "officeMeetReferralPayment"
                                        : "kickOffReferralPayment")}
                                />

                                {dialogStep === 1 ? "Site Visit Referral Payment" : "Design Signoff Referral Payment"}
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    {dialogStep === 2 && <Button onClick={handlePrevious} color="primary">Previous</Button>}
                    { selectedLead?.leadId?.leadStatus === "Won" && dialogStep === 1
                        ? <Button onClick={handleNext} color="secondary">Next</Button>
                        : <Button onClick={handleCloseDialog} color="secondary">Close</Button>
                    }
                </DialogActions>
            </Dialog>

            {/* Dialog for Bank Details */}
            <Dialog open={openBankDialog} onClose={handleCloseBankDialog} maxWidth="sm" fullWidth>
                <DialogTitle>Bank Details</DialogTitle>
                <DialogContent>
                    {selectedBankDetails && (
                        <>
                            <Typography><b>Account Holder:</b> {selectedBankDetails.accountHolder}</Typography>
                            <Typography><b>Bank Name:</b> {selectedBankDetails.bankName}</Typography>
                            <Typography><b>Branch Name:</b> {selectedBankDetails.branchName}</Typography>
                            <Typography><b>Account Number:</b> {selectedBankDetails.accountNumber}</Typography>
                            <Typography><b>IFSC Code:</b> {selectedBankDetails.ifscCode}</Typography>
                            <Typography><b>Email:</b> {selectedBankDetails.email}</Typography>
                            <Typography><b>Unique Lead No/ERP Project No:</b> {selectedBankDetails.uniqueLeadNumber}</Typography>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseBankDialog} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
};


export default connect(null, { setLoading, setSnackInfo })(Referral);